/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ForcingSubstance
 */
export interface ForcingSubstance {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substance: string;
  /**
   *
   */
  readonly substanceId?: number;
  /**
   *
   */
  readonly substanceName?: string;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  concentrations: Array<Array<number>>;
}

/**
 * Check if a given object implements the ForcingSubstance interface.
 */
export function instanceOfForcingSubstance(value: object): value is ForcingSubstance {
  if (!("substance" in value) || value["substance"] === undefined) return false;
  if (!("concentrations" in value) || value["concentrations"] === undefined) return false;
  return true;
}

export function ForcingSubstanceFromJSON(json: any): ForcingSubstance {
  return ForcingSubstanceFromJSONTyped(json, false);
}

export function ForcingSubstanceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ForcingSubstance {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    substance: json["substance"],
    substanceId: json["substance_id"] == null ? undefined : json["substance_id"],
    substanceName: json["substance_name"] == null ? undefined : json["substance_name"],
    concentrations: json["concentrations"],
  };
}

export function ForcingSubstanceToJSON(json: any): ForcingSubstance {
  return ForcingSubstanceToJSONTyped(json, false);
}

export function ForcingSubstanceToJSONTyped(
  value?: Omit<ForcingSubstance, "id" | "substanceId" | "substanceName"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    substance: value["substance"],
    concentrations: value["concentrations"],
  };
}
